// Module
var code = "<div class=\"alert <%= type %> <%= subclass %> fade in\"> <a class=\"close\" title=\"close\">×</a> <strong><%= message %></strong> </div> ";
// Exports
module.exports = code;